import { createSlice } from '@reduxjs/toolkit';

export type turnActionType = {
  callAmount: string;
  action: string[];
};
interface CommonSlice {
  isMobile: boolean;
  preCheckAction: turnActionType;
  lastStage: string;
  showRabbitHuntingCards: boolean;
  playAddress: string; // sit down 之后 或 create game 时 表示游戏用到的address
  showValidateModal: React.ReactNode; // 展示validate modal(如connect modal, switchAccount modal)
}

const initialState: CommonSlice = {
  isMobile: false,
  preCheckAction: { callAmount: '0', action: [] },
  lastStage: '',
  showRabbitHuntingCards: false, // 是否展示rabbit hunting 卡牌
  playAddress: '',
  showValidateModal: '',
};
export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setIsMobile: (state, action) => {
      state.isMobile = action.payload;
    },
    setPreCheckAction: (state, action) => {
      state.preCheckAction = action.payload;
    },
    setLastStage: (state, action) => {
      state.lastStage = action.payload;
    },
    setShowRabbitHuntingCards: (state, action) => {
      state.showRabbitHuntingCards = action.payload;
    },
    setPlayAddress: (state, action) => {
      state.playAddress = action.payload;
    },
    setShowValidateModal: (state, action) => {
      state.showValidateModal = action.payload;
    },
  },
});

export const {
  setIsMobile,
  setPreCheckAction,
  setLastStage,
  setShowRabbitHuntingCards,
  setPlayAddress,
  setShowValidateModal,
} = commonSlice.actions;

export default commonSlice.reducer;
